import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';
import { Input as RSInput } from 'reactstrap';
import { CustomView, MobileView, isAndroid, isIOS } from 'react-device-detect';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { uniqueId } from 'lodash';
import useValue from '../../services/Form/useValue';
import { t, numStr } from '../common/Translate';
import { calendarLang } from '../../language-context';
import { Auth } from '../../config/configuration/react';

const Input = (props) => {
  const { elementIds, autoFocus } = props;
  const { questionId, sectionId, formId } = elementIds;
  const { question, setDisableNav } = props;
  const defaultValue = question.default_value;
  const [value, setValue] = useValue(formId, sectionId, questionId, question.type, 'value', defaultValue);
  const [tmpValue, setTmpValue] = useState('');
  const datePickerRef = useRef();
  const [errorMessage, setErrorMessage] = useState(true);
  const appLang = Auth.preferredLanguage();

  useEffect(() => {
    if (value === undefined || value === null) setTmpValue('');
    else setTmpValue(value);
  }, [value]);

  const checkValidity = (v, name) => {
    if (['integer', 'km', 'number'].includes(question.type)) {
      let _value = v;
      try {
        _value = parseInt(_value, 10);
      } catch (e) {
        setErrorMessage(`${t(name)} ${t('should_be_a_number')}`);
        return false;
      }
      if (question.min !== undefined && _value < question.min) {
        setErrorMessage(`${t(name)} ${t('input_error_value_must_be_greater_than')} ${question.min}`);
        return false;
      }
      if (question.max !== undefined && _value > question.max) {
        setErrorMessage(`${t(name)} ${t('input_error_value_must_be_lower_than')} ${question.max}`);
        return false;
      }
      if (name === 'client_zip' && _value.toString().length > 5) {
        setErrorMessage(`${t(name)} ${t('input_error_value_must_be_lower_than_6')}`);
        return false;
      }
      return true;
    }
    return true;
  };
  const handleInput = (event) => {
    const { name } = event.target;
    if (name === 'client_zip') {
      const inputElement = event.target;
      const saisie = inputElement.value;
      const lastCaractere = saisie.slice(-1);
      const regex = /^[a-zA-Z0-9]*$/;
      if (!regex.test(lastCaractere)) {
        const newValue = saisie.slice(0, -1);
        inputElement.value = newValue;
      }
    }
  };
  const handleChange = (e) => {
    const { name } = e.target;
    let _inputValue = e.target.value;
    if (checkValidity(_inputValue, name)) setErrorMessage(false);
    if (['last_servicing_km', 'vehicule_test_mileage'].includes(name) && _inputValue) {
      _inputValue = _inputValue.replace(/[^0-9]/g, '');
      if (_inputValue.length > 6) return;
      setTmpValue(_inputValue);
    } else setTmpValue(_inputValue);
  };
  const saveData = (e) => {
    if (tmpValue === '') setValue(null);
    else if (
      e.target.type === 'month' &&
      (tmpValue.split('-')[0].length > 4 || tmpValue.split('-')[0] < '1950' || tmpValue.split('-')[0] > '2100')
    ) {
      setTmpValue('');
    } else {
      setValue(tmpValue);
    }
  };

  useEffect(() => {
    if (setDisableNav !== undefined) {
      if (tmpValue !== null && tmpValue !== '' && tmpValue !== undefined && checkValidity(tmpValue))
        setDisableNav(false);
      else setDisableNav(true);
    }
  });

  let inputmode;
  let pattern;
  let maxLength;
  let { type } = question;
  let placeholder = '';
  if (question.placeholder !== undefined) placeholder = t(question.placeholder);

  if (question.type === 'string') {
    type = 'text';
    if (question.id === 'client_zip') {
      pattern = '[0-9A-Za-z]{1,7}';
      maxLength = '7';
    }
  }
  if (['integer', 'km', 'number'].includes(question.type)) {
    if (question.mask === undefined) {
      if (['number', 'integer'].includes(question.type) && question.id !== 'vehicule_test_mileage') {
        question.mask = '999999999999';
      }
    }
    inputmode = 'tel';
    pattern = '[0-9]*';
    type = 'tel';
    question.maskChar = '';
    if (question.id === 'client_zip') {
      pattern = '[0-9]{5}';
      maxLength = '5';
    }
  }

  if (question.type === 'textarea') {
    return (
      <>
        <div className="question-input">
          <RSInput
            type="textarea"
            rows={4}
            name={question.id}
            autoFocus={autoFocus}
            id={question.id}
            value={tmpValue}
            placeholder={placeholder}
            onChange={(e) => handleChange(e)}
            onBlur={(e) => saveData(e)}
            data-cy={questionId}
          />
        </div>
      </>
    );
  }

  if (question.type === 'dropdowns') {
    return (
      <>
        <div className="question-input">
          <RSInput
            type="select"
            name={question.id}
            data-cy={question.id}
            onChange={(e) => handleChange(e)}
            value={tmpValue}
            onBlur={(e) => saveData(e)}
            className="form-control rounded border-select"
            autoFocus={autoFocus}
          >
            <option value={0}>{`${t('select')}`}</option>
            {question.options.map((opt) => (
              <option key={opt.id} value={parseInt(opt.id, 10)}>
                {opt.name}
              </option>
            ))}
          </RSInput>
        </div>
      </>
    );
  }

  if (question.type === 'date' || question.type === 'month') {
    const minValue = question.min;
    const maxValue = question.max;
    const formDateValue = question.type === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM';
    const onFocus = (e) => {
      e.currentTarget.type = question.type;
    };

    const onBlur = (e) => {
      if (!e.target.value) {
        // e.currentTarget.type = 'text';
      } else {
        e.currentTarget.type = question.type;
      }
      e.currentTarget.placeholder = e.target.placeholder;
    };
    const generateYearOptions = (currentYear) => {
      const yearOptions = [];
      for (let i = currentYear - 20; i <= currentYear + 20; i++) {
        yearOptions.push({ value: i, label: i.toString() });
      }
      return yearOptions;
    };
    const renderCustomHeader = ({ date, changeYear, changeMonth }) => {
      const currentYear = date.getFullYear();
      const currentMonth = date.getMonth();
      const yearOptions = generateYearOptions(currentYear);
      const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      return (
        <div
          className="react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--scroll"
          style={{ height: question.type === 'date' ? '30px' : '0px' }}
        >
          <select
            className="react-datepicker__month-year-dropdown border-0"
            style={{ top: question.type === 'date' ? 2 : 8 }}
            value={currentYear}
            onChange={({ target }) => changeYear(parseInt(target.value, 10))}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                setValue(moment([currentYear, date.getMonth()]).format(formDateValue));
                datePickerRef.current.setOpen(false);
              }
            }}
          >
            {yearOptions.map((option) => (
              <option key={option.value} value={option.value} className="">
                {option.label}
              </option>
            ))}
          </select>
          {question.type === 'date' && (
            <select
              className="react-datepicker__month-year-dropdown border-0"
              style={{ top: 23 }}
              value={currentMonth}
              onChange={({ target }) => changeMonth(parseInt(target.value, 10))}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setValue(moment([currentYear, currentMonth]).format(formDateValue));
                  datePickerRef.current.setOpen(false);
                }
              }}
            >
              {monthNames.map((month, index) => (
                <option
                  key={uniqueId(index)}
                  value={index}
                  className={`react-datepicker__month-option ${
                    index === currentMonth ? 'react-datepicker__month-option--selected_month' : ''
                  }`}
                >
                  {month}
                </option>
              ))}
            </select>
          )}
        </div>
      );
    };
    return (
      <>
        <div className="question-input">
          <CustomView condition={!isAndroid && !isIOS}>
            <DatePicker
              ref={datePickerRef}
              className="form-control"
              name={question.id}
              id={question.id}
              onChange={(e) => setValue((e && moment(e).format(formDateValue)) || null)}
              selected={(tmpValue && new Date(tmpValue)) || ''}
              locale={calendarLang[appLang]}
              dateFormat={question.type === 'date' ? 'dd MMMM yyyy' : 'MMMM yyyy'}
              placeholderText={t(formDateValue)}
              autoComplete="off"
              showMonthYearPicker={question.type !== 'date'}
              showYearDropdown
              scrollableYearDropdown
              yearItemNumber={10}
              renderCustomHeader={renderCustomHeader}
              onKeyDown={(e) => e.preventDefault()}
            />
          </CustomView>
          <MobileView>
            <RSInput
              type={type}
              name={question.id}
              id={question.id}
              // autoFocus={props.autoFocus}
              className={tmpValue !== '' ? 'has-value' : ''}
              value={tmpValue}
              placeholder={t('MM/YYYY')}
              onChange={(e) => handleChange(e)}
              onFocus={(e) => onFocus(e)}
              onBlur={(e) => {
                onBlur(e);
                saveData(e);
              }}
              min={minValue}
              max={maxValue}
              data-cy={question.id}
            />
          </MobileView>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="question-input">
        <InputMask
          mask={question.mask}
          maskChar={question.maskChar}
          type={type}
          name={question.id}
          data-cy={question.id}
          inputMode={inputmode}
          pattern={pattern}
          value={
            (question.id === 'last_servicing_km' || question.id === 'vehicule_test_mileage') && tmpValue !== ''
              ? numStr(tmpValue)
              : tmpValue
          }
          className="form-control"
          autoFocus={autoFocus}
          placeholder={placeholder}
          onInput={(e) => handleInput(e)}
          onChange={(e) => handleChange(e)}
          onBlur={(e) => saveData(e)}
          maxLength={maxLength}
        />
        {errorMessage && <p className="text-center text-danger">{errorMessage}</p>}
      </div>
    </>
  );
};

export default Input;

Input.propTypes = {
  question: PropTypes.shape().isRequired,
  elementIds: PropTypes.shape().isRequired,
  setDisableNav: PropTypes.bool,
  autoFocus: PropTypes.bool,
};

Input.defaultProps = {
  setDisableNav: undefined,
  autoFocus: undefined,
};
